import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_VDAY_80: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_VDAY_80,
  },
  {
    pageId: PageId.CHAT_UPSELL_VDAY_80,
  },
  {
    pageId: PageId.UPSELL_VDAY_80,
  },
  {
    pageId: PageId.DOWNLOAD_VDAY_80,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
